import { FaPaintBrush, FaBolt, FaWrench } from 'react-icons/fa';

const WhyChooseUs = () => {
  return (
    <div >
      <section
        id="features"
        className="relative block px-6 py-10 md:py-20 md:px-10  bg-cyan-900 w-11/12 mx-auto"

      >
        <div className="relative mx-auto max-w-5xl text-center">
          <span className="text-white my-3 flex items-center justify-center font-medium uppercase tracking-wider">
            Why choose us
          </span>
          <h2 className="block w-full bg-gradient-to-b from-white to-white bg-clip-text font-bold text-transparent text-3xl sm:text-4xl">
          GetOffMyPavement.co.uk is Your Best Choice
          </h2>
          <p className="mx-auto my-4 w-full max-w-x2 bg-transparent text-center  leading-relaxed tracking-wide text-white">
          We understand the frustration of pavement parking. That’s why we’ve made it simple and stress-free for you to take action. With our trusted service ensures you reclaim your space without the hassle. Protect your property and your peace of mind with us by your side.
          </p>
        </div>

        <div className="relative mx-auto max-w-7xl z-10 grid grid-cols-1 gap-10 pt-14 sm:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-md  bg-gray-800 p-8 text-center shadow">
            <div
              className="button-text bg-white mx-auto flex h-12 w-12 items-center justify-center rounded-md border"
              
            >
              <FaPaintBrush size={24} color="currentColor" />
            </div>
            <h3 className="mt-6 text-white font-bold">Simple Process</h3>
            <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-white">
            Just provide a few details, and we handle everything else.
            </p>
          </div>

          <div className="rounded-md  bg-gray-800 p-8 text-center shadow">
            <div
              className="button-text bg-white mx-auto flex h-12 w-12 items-center justify-center rounded-md border"
             
            >
              <FaBolt size={24} color="currentColor" />
            </div>
            <h3 className="mt-6 text-white font-bold">Trusted Team</h3>
            <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-white">
            Our team works tirelessly on your behalf to hold pavement parkers accountable. 
            </p>
          </div>

          <div className="rounded-md  bg-gray-800 p-8 text-center shadow">
            <div
              className="button-text bg-white mx-auto flex h-12 w-12 items-center justify-center rounded-md border"
             
            >
              <FaWrench size={24} color="currentColor" />
            </div>
            <h3 className="mt-6 text-white font-bold">Peace of Mind</h3>
            <p className="my-4 mb-0 font-normal leading-relaxed tracking-wide text-white">
            Feel secure knowing you’ve taken effective action to protect your property.
            </p>
          </div>
        </div>

        <div
          className="absolute bottom-0 left-0 z-0 h-1/3 w-full border-b"
          style={{
            backgroundImage:
              'linear-gradient(to right top, rgba(79, 70, 229, 0.2) 0%, transparent 50%, transparent 100%)',
            borderColor: 'rgba(92, 79, 240, 0.2)',
          }}
        ></div>
        <div
          className="absolute bottom-0 right-0 z-0 h-1/3 w-full"
          style={{
            backgroundImage:
              'linear-gradient(to left top, rgba(220, 38, 38, 0.2) 0%, transparent 50%, transparent 100%)',
            borderColor: 'rgba(92, 79, 240, 0.2)',
          }}
        ></div>
      </section>
    </div>
  );
};

export default WhyChooseUs;
